import React, { useEffect } from 'react';
import './Pro.css';

const Pro = ({ hidden, toggleFooter }) => {
  useEffect(() => {
    toggleFooter(false);
  }, [toggleFooter]);

  return (
    <div className="pro-page-wrapper">
      <div className="pro-header">
        <h1>Espace Professionnels</h1>
        <p>Pour vous offrir un meilleur service, notre système de commande a évolué.</p>
        <p>Retrouvez désormais notre catalogue et passez vos commandes directement sur notre espace producteur :</p>
      </div>

      <div className="pro-content-card" style={{ textAlign: 'center', padding: '50px 0' }}>
        {/* Le bouton de redirection simple et sans prise de tête */}
        <a
          href="https://boutique.ouvretaferme.org/la-ferme-du-fersac"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: '15px 30px',
            backgroundColor: '#4CAF50',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            display: 'inline-block',
            fontSize: '18px',
            fontWeight: 'bold',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}
        >
          Accéder à l'espace Pro
        </a>
      </div>
    </div>
  );
};

export default Pro;